export const ADD_ON_IDS = {
  SMS: 'CTCT-SMS-ADDON',
  IBP: 'CTCT-INBOX-PREVIEW-101',
};

/** Prefix shared by US, AU, GB, and future SMS market addon ids. */
export const SMS_MARKET_ADDON_ID_PREFIX = 'CTCT-SMS-ADDON';

export const FE_ADD_ON_ID = {
  XERO: 'XERO-ADDON',
};
